

<div class="background-icons-animation__wrapper">
	<div class="background-icons-animation__icons-container container">
		<div class="background-icons-animation__icons-row" *ngFor="let iconsRow of selectedIcons; let index = index" [ngClass]="{ 'has-padding': (index % 2 == 0) }">
			<app-svg aria-hidden="true" class="icon" [ngClass]="icon.class" [svg]="icon.id" [style.padding]="icon.position" *ngFor="let icon of iconsRow"></app-svg>
		</div>
	</div>
	<div class="background-icons-animation__text-container">
		<h2 class="title-h2" skeletonLoader [translationKey]="titleKey">
			{{title}}
		</h2>
		<span class="description" skeletonLoader [translationKey]="descriptionKey">
			{{description}}
		</span>
		<div class="background-icons-animation__dots-container">
			<span class="dot">.</span><span class="dot dot--2">.</span><span class="dot dot--3">.</span>
		</div>
	</div>
</div>
